import styled from 'styled-components';
import { isDefined } from 'utils/tsHelpers';
import { InsightPanel } from './InsightPanel';
import { InsightPanelSize } from './types';
import { useTranslation } from '../hooks';
import { InsightType } from '../domain';

type NumberInsightPanelProps = {
  title: string;
  value?: string;
  isLoading?: boolean;
  type?: InsightType;
  isZero?: boolean;
  isCustom?: boolean;
};

const NumberWrapper = styled.div<{ $isDefined?: boolean }>`
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing.values.half};
  color: ${({ theme }) => theme.colors.textColors.textPrimary};
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  font-size: 20px;
  font-weight: bold;
  min-width: ${({ theme }) => theme.spacing.utils.pxToRem(169)};

  /** $isDefined pertains to values that are not undefined or 0 */

  ${({ theme, $isDefined }) =>
    !$isDefined &&
    `
    ${theme.styles.body.body2};
    font-weight: 400;
    font-size: ${theme.styles.fontSizes.s14};
    color: ${theme.colors.textColors.textSecondary};
  `};
`;

export const NumberInsightPanel = ({
  title,
  value,
  type,
  isZero = false,
  isCustom = false,
}: NumberInsightPanelProps) => {
  const { t } = useTranslation();
  /** a value should only be undefined if it's still processing due to cache */

  const getPlaceholderMessage = () => {
    if (isCustom && !isDefined(value)) {
      return t('insights.placeholder.behavioral');
    } else if (!isCustom && !isDefined(value)) {
      return t('insights.empty.data');
    } else {
      return value;
    }
  };

  return (
    <InsightPanel type={type} title={title} colSpan={1} size={InsightPanelSize.small}>
      <NumberWrapper $isDefined={!isZero && isDefined(value)}>
        {getPlaceholderMessage()}
      </NumberWrapper>
    </InsightPanel>
  );
};
